<template>
    <iModal v-model="visible" :z-index="1010" @on-cancel="close" class-name="login-modal" width="420" :closable="false"
        footer-hide>
        <div class="g-login">
            <div class="g-login-box">
                <span class="box-btn box-1" @click="loginCode" :class="{ 'backImg_Color': isPwd }">Email Login</span>
                <span class="box-btn" style="cursor: pointer;" @click="loginPwd"
                    :class="{ 'backImg_Color': !isPwd }">Exhibitor Login </span>
            </div>

            <div class="g-login-content">
                <div style="height:30px"></div>
                <!-- <div class="content-top">
          <p
            class="p2"
            :class="isPwd ? 'active' : ''"
            style="text-align: left"
            @click="loginPwd"
          >
            Login via password
          </p>
          <p
            class="p2"
            :class="!isPwd ? 'active' : ''"
            style="text-align: right"
            @click="loginCode"
          >
            Login via verification code
          </p>
        </div> -->
                <!-- 邮箱登录  邮箱验证码-->
                <div class="content-bottom-2" v-show="!isPwd">
                    <Form class="Form2" ref="formInline2" :model="formInline2" :rules="ruleInline2"
                        @keyup.enter.native="handleSubmit2('formInline2')">
                        <FormItem prop="phone2">
                            <Input type="text" v-model="formInline2.phone2" placeholder="Email" />
                        </FormItem>
                        <!-- <FormItem class="Form-2" prop="imgCode2">
                            <Input v-model="formInline2.imgCode2" placeholder="Captcha" />
                            <img class="Form-2-code" :src="code2.image" alt="Captcha" v-if="code2 && code2.image"
                                @click="getCode2" />
                        </FormItem> -->

                        <FormItem class="Form-2-txtCode" prop="captcha">
                            <Input type="text" v-model="formInline2.captcha" placeholder="Verification code：" />
                            <Button type="text" v-if="showCode" @click="getCaptcha" class="form-code-btn">Get verification
                                code</Button>
                            <Button type="text" v-else disabled class="form-code-btn" style="color: #ccc">
                                Please try again after{{ count }}seconds</Button>
                            <p class="Form-2-text">
                                <!-- Forget password? -->
                            </p>
                        </FormItem>

                        <Button type="primary" @click="handleSubmit2('formInline2')" size="large" :loading="loading2"
                            style="width: 100%; height: 42px;margin-top:10px">Login</Button>
                        <p class="onBoardCss">Onboard iCMEF for business opportunities</p>

                        <p class="login-re">
                            <span @click="$router.push('/loginEn/registerEn')">No account? Register now</span>
                        </p>
                    </Form>
                </div>

                <!-- 展商登录  账号密码 -->
                <div class="content-bottom-1" v-show="isPwd">
                    <Form class="Form1" ref="formInline" :model="formInline" :rules="ruleInline"
                        @keyup.enter.native="handleSubmit('formInline')">
                        <FormItem prop="phone">
                            <Input type="text" v-model="formInline.phone" placeholder="Account" />
                        </FormItem>
                        <FormItem prop="password">
                            <Input type="password" v-model="formInline.password" placeholder="Password" />
                        </FormItem>
                        <FormItem class="Form-1" prop="imgCode">
                            <Input v-model="formInline.imgCode" placeholder="Captcha" />
                            <img class="Form-1-code" :src="code.image" alt="Captcha" v-if="code && code.image"
                                @click="getCode" />
                        </FormItem>
                        <FormItem style="margin-bottom: 0">
                             <!-- <Checkbox class="save-btn" v-model="remember">Remember the Password</Checkbox>  -->
                            <!-- <p class="Form-1-text" style="top: 0" @click="$router.push('/loginEn/reset-passwordEn')"> -->
                            <p class="Form-1-text" style="top: 0     margin-top: -15px;" @click="modalChange()">
                                Forget password?
                            </p>
                        </FormItem>
                        <Button type="primary" @click="handleSubmit('formInline')" size="large" :loading="loading"
                            style="width: 100%; height: 42px; margin-top: 10px">Login</Button>
                        <p class="onBoardCss">Onboard iCMEF for business opportunities</p>
                        <p class="login-re">
                            <span @click="$router.push('/loginEn/registerEn')">No account? Register now</span>
                        </p>
                    </Form>
                </div>


            </div>
            <div class="g-login-close">
                <i class="icon iconfont icon-guanbi3" @click="close"></i>
            </div>
        </div>

        <iModal :z-index="1020" v-model="modal10" class-name="vertical-center-modal" ok-text="确定" cancel-text="取消">
            <p class="modalI">To retrieve your password</p>
            <p class="modalI">please contact:010-84556507</p>
        </iModal>
    </iModal>
</template>

<script>
import config from "@assets/config.json";
import CryptoJS from "crypto-js";
import { validator } from "@/other/validatorEn";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
    name: "g-login",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        isPwd: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            companyList:[],
            visible: false,
            // isPwd: false,
            modal10: false,

            // 密码登录
            loading: false,
            formInline: {
                phone: "",
                imgCode: "",
                password: "",
            },
            ruleInline: {
                phone:  [
                    {
                        required: true,
                        message: "account cannot be empty",
                        trigger: "blur",
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "password cannot be empty",
                        trigger: "blur",
                    },
                    {
                        type: "string",
                        min: 4,
                        message: "Password cannot be less than 4 digits",
                        trigger: "blur",
                    },
                    {
                        type: "string",
                        max: 50,
                        message: "密码不能大于50位",
                        trigger: "blur",
                    },
                ],
                imgCode: [
                    {
                        required: true,
                        message: "Please enter the correct captcha on the picture",
                        trigger: "blur",
                    },
                ],
            },
            code: null, // 图片验证码信息

            // 验证码登录
            loading2: false,
            formInline2: {
                phone2: "",
                // imgCode2: "",
                captcha: "",
            },
            ruleInline2: {
                phone2: validator.email,
                // imgCode2: [
                //     {
                //         required: true,
                //         message: "Please enter the correct captcha on the picture",
                //         trigger: "blur",
                //     },
                // ],
                captcha: [
                    {
                        required: true,
                        message: "Please enter the correct captcha/请输入验证码",
                        trigger: "blur",
                    },
                ],
            },
            code2: null, // 图片验证码信息
            showCode: true, // 是否可以获取验证码
            count: "", // 获取验证码的秒数
            remember: false, // 记住密码
        };
    },
    watch: {
        show (val, oldVal) {
            this.visible = val;
        },
    },
    computed: {
        ...mapGetters({}),
    },
    created () {
        let name = this.$cookies.get("pc-name");
        let pwd = this.$cookies.get("pc-pwd");
        if (name && pwd) {
            let password = CryptoJS.AES.decrypt(pwd, "GYPC-key").toString(
                CryptoJS.enc.Utf8
            );
            // console.log("解密结果：" + password);
            this.remember = true;
            this.formInline.phone = name;
            this.formInline.password = password;
        }
        this.getCode();
        this.getCode2();
    },
    methods: {
        ...mapMutations({
            setToken: "setToken",
            setLogin: "setLogin",
            setTokenTime: "setTokenTime",
        }),
        ...mapActions({
            getImgCode: "loginModule/getImgCode",
            validateImgCode: "loginModule/validateImgCode",
            getUser: "loginModule/getUser",
            getToken: "loginModule/getToken",
            getCompany: "loginModule/getCompany",
            getByCompId: "loginModule/getByCompId",
            getMsgCode: "loginModule/getMsgCode",
            getByProduct: "loginModule/getByProduct",
            getMsgCodeEmail: "loginModule/getMsgCodeEmail",
            validateMsgCode: "loginModule/validateMsgCode",
            validateEmailCode: "loginModule/validateEmailCode",
        }),

        modalChange () {
            this.modal10 = true
        },
        loginPwd () {
            if (!this.isPwd) {
                this.isPwd = true;
                this.$refs["formInline2"].resetFields();
            }
        },
        loginCode () {
            if (this.isPwd) {
                this.isPwd = false;
                this.$refs["formInline"].resetFields();
            }
        },
        close () {
            if (this.isPwd) {
                this.formInline.phone = "";
                this.formInline.imgCode = "";
                this.formInline.password = "";
                this.loading = false;
                this.$refs["formInline"].resetFields();
                let name = this.$cookies.get("pc-name");
                let pwd = this.$cookies.get("pc-pwd");
                if (name && pwd) {
                    this.remember = true;
                } else {
                    this.remember = false;
                }
            } else {
                this.loading2 = false;
                this.formInline2.phone2 = "";
                this.formInline2.imgCode2 = "";
                this.$refs["formInline2"].resetFields();
            }
            this.isPwd = true;
            this.$emit("close");
        },
        async handleSubmit (name) {
            let valid = await this.validForm(name);
            if (!valid) return;
            let codeValid = await this.validCode();
            if (!codeValid) return;
            let formData = {
                username: this.formInline.phone,
                password: this.formInline.password,
                grant_type: "password",
                client_id: "cloud.exhibition",
                client_secret: "secret",
                scope: "synair offline_access",
                // login_type: "phone",
            };
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 5000);
            let tokenData = await this.getToken(formData);
            console.log(tokenData,'0000000');

            if (tokenData) {
                if (this.remember) {
                    let pwd = CryptoJS.AES.encrypt(
                        String(this.formInline.password),
                        "GYPC-key"
                    ).toString();
                    // console.log("加密结果"+ pwd);
                    this.$cookies.set("pc-name", this.formInline.phone, 60 * 60 * 24 * 7);
                    this.$cookies.set("pc-pwd", pwd, 60 * 60 * 24 * 7);
                } else {
                    this.$cookies.remove("pc-name");
                    this.$cookies.remove("pc-pwd");
                }
                this.$Message.success("Login succeeded");
                sessionStorage.removeItem('emailLogin')
                sessionStorage.setItem('accountPassword', true)
                this.$store.commit('setIsExLogin', '展商', { root: true });

                this.setToken(tokenData.access_token);
                this.setTokenTime(tokenData.expires_in * 1000 + new Date().getTime());
                let user = await this.getUser();
                if(user.userId){
               this.companyList= await this.getCompany(user.userId);
               let byCompIdList= await this.getByCompId(this.companyList.id);
                    sessionStorage.setItem('compId', this.companyList.id)

               let proList= await this.getByProduct({
                CompId:  this.companyList.id,
                pageIndex: 1,
                pageSize: 50
               });
            console.log(this.companyList, byCompIdList,proList,'2222222222222222222222222222222222');

               this.$emit('btnclick', this.companyList, byCompIdList,proList)


             sessionStorage.setItem('companyListLogin',JSON.stringify(this.companyList))
             sessionStorage.setItem('byCompIdListLogin',JSON.stringify(byCompIdList))
             sessionStorage.setItem('proListLogin',JSON.stringify(proList))


                }

                this.setLogin(true);
                this.close();
            }
            this.loading = false;
        },
        async handleSubmit2 (name) {
            let form = this.formInline2;
            let valid = await this.validForm2(name);
            if (!valid) return;
            let codeValid = await this.validMsgCode();
            if (!codeValid) return;
            let formData = {
                // grant_type: "password",
                // client_id: "cloud.exhibition",
                // client_secret: "secret",
                // username: form.phone2,
                // password: "000000",
                // scope: "synair offline_access",
                // login_type: "phonecode",
                grant_type:'emailCode',
                client_id:'cloud.exhibition',
                client_secret:'secret',
                scope:'synair offline_access',
                email:this.formInline2.phone2
            };
            this.loading2 = true;
            setTimeout(() => {
                this.loading2 = false;
            }, 5000);
            let tokenData = await this.getToken(formData);
            if (tokenData) {
                sessionStorage.removeItem('accountPassword')

                sessionStorage.setItem('emailLogin', true)
                this.$store.commit('setIsExLogin', '个人', { root: true });
                this.$Message.success("Login succeeded")
                this.setToken(tokenData.access_token);
                this.setTokenTime(tokenData.expires_in * 1000 + new Date().getTime());
                let user = await this.getUser();

                this.setLogin(true);
                this.close();
            }
            this.loading2 = false;
        },
        async getCode () {
            // 获取code
            this.code = await this.getImgCode();
        },
        async getCode2 () {
            // 获取code
            this.code2 = await this.getImgCode();
        },
        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid);
                });
            });
        },
        validForm2 (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid);
                });
            });
        },
        async validCode () {
            // 验证图片验证码
            if (!this.code || !this.formInline.imgCode) return false;
            let valid = await this.validateImgCode({
                Key: this.code.key,
                Code: this.formInline.imgCode,
            });
            if (!valid) {
                this.$Message.error("验证未通过!");
                return false;
            }
            if (valid.errors && valid.errors[0]) {
                this.$Message.error(valid.errors[0].description);
                this.getCode();
                return false;
            }
            return true;
        },
        async validCode2 () {
            // 验证图片验证码
            if (!this.code2 || !this.formInline2.imgCode2) return false;
            let valid = await this.validateImgCode({
                Key: this.code2.key,
                Code: this.formInline2.imgCode2,
            });
            if (!valid) {
                this.$Message.error("验证未通过!");
                return false;
            }
            if (valid.errors && valid.errors[0]) {
                this.$Message.error(valid.errors[0].description);
                this.getCode2();
                return false;
            }
            return true;
        },
        async validMsgCode () {
            // 验证code
            if (!this.formInline2.captcha) return false;
            let valid = await this.validateEmailCode({
                email: this.formInline2.phone2,
                Code: this.formInline2.captcha,
            });
            if (!valid.successed) {
                if (valid.errors && valid.errors[0]) {
                    this.$Message.error(valid.errors[0].description);
                } else {
                    this.$Message.error("验证未通过!");
                }
                return false;
            }
            return true;
        },
        async getCaptcha () {
            this.$refs.formInline2.validateField("phone2", (val) => { });
            // this.$refs.formInline2.validateField("imgCode2", (val) => { });
            // let codeValid = await this.validCode2();
            // if (!codeValid) return;
            this.$refs.formInline2.validateField("phone2", (val) => {
                if (val !== "") return;
                this.downTime();
            });
        },
        async downTime () {
            const valid = await this.getMsgCodeEmail(this.formInline2.phone2);
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.showCode = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.showCode = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
            }
        },

        linkToEx () {
            window.open(`${config.BackendUrl}/exhibitionEn/login/alogin`);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .login-modal {
    .ivu-modal-body {
        padding: 0;
        border-radius: 2px;
    }

    .ivu-modal-content {
        border-radius: 2px;
    }
}

.g-login {
    position: relative;
    border-radius: 2px;

    &-box {
        border-radius: 2px;
        height: 50px;

        .box-btn {
            display: inline-block;
            width: 50%;
            height: 100%;
            text-align: center;
            line-height: 50px;
            font-size: 16px;
            // color: #666;
        }

        .box-1 {
            border-radius: 2px 0 0 2px;
        }
    }

    &-content {
        .content-top {
            width: 330px;
            padding: 45px 0 20px;
            margin: 0 auto;

            .p2 {
                display: inline-block;
                width: 50%;
                text-align: center;
                font-size: 14px;
                line-height: 16px;
                cursor: pointer;
                color: #666;

                &.active,
                &:hover {
                    color: #d13119;
                }
            }
        }

        .content-bottom-1 {
            width: 300px;
            margin: 0 auto;

            .Form1 {
                ::v-deep .ivu-input {
                    height: 42px;
                }

                .Form-1 {
                    position: relative;

                    &-code {
                        position: absolute;
                        right: 6px;
                        top: 6px;
                        cursor: pointer;
                    }

                    &-text {
                        // position: absolute;
                        top: 40px;
                        right: 0;
                        text-align: right;
                        cursor: pointer;
                    }
                }

                .login-re {
                    text-align: center;
                    padding: 0px 0 20px 0;
                    color: #666;

                    span {
                        cursor: pointer;
                        text-decoration: underline;
                    }
                }
            }
        }

        .content-bottom-2 {
            width: 300px;
            margin: 0 auto;

            .Form2 {
                ::v-deep .ivu-input {
                    height: 42px;
                }

                .Form-2 {
                    position: relative;

                    &-code {
                        position: absolute;
                        right: 6px;
                        top: 6px;
                        cursor: pointer;
                    }

                    &-text {
                        // position: absolute;
                        // top: 40px;
                        right: 0;
                        text-align: right;
                        cursor: pointer;
                    }
                }

                .Form-2-txtCode {
                    position: relative;

                    .form-code-btn {
                        position: absolute;
                        right: -8px;
                        top: 5px;
                        border: none;
                        outline: none;
                        background: transparent !important;
                        color: #1890ff;

                        &:focus {
                            box-shadow: none;
                            border: none;
                            outline: none;
                        }
                    }
                }

                .login-re {
                    text-align: center;
                    padding: 0px 0 20px 0;
                    color: #666;

                    span {
                        cursor: pointer;
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    &-close {
        position: absolute;
        top: -40px;
        right: -30px;

        i {
            font-size: 40px;
            color: #fff;
            cursor: pointer;
        }
    }
}

.vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
        top: 0;
    }
}

.modalI {
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: large;
}

.backImg_Color {
    background-color: #024c8b;
    color: #fff
}

.onBoardCss {
    text-align: center;
    margin-top: 10px;
    font-weight: bold;
}
</style>
